"use strict";
var ApiSublimit = (function () {
    function ApiSublimit() {
    }
    return ApiSublimit;
}());
exports.ApiSublimit = ApiSublimit;
//# sourceMappingURL=D:/a/1/s/base/src/models/api-sublimit.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/base/src/models/api-sublimit.model.js